import React, { Fragment } from 'react';

import PropTypes from 'prop-types';
import withStyles from '@material-ui/core/styles/withStyles';
import { Tooltip, Typography } from '@material-ui/core';

import WarningIcon from '@material-ui/icons/Warning';

import InfoOutlinedIcon from '@material-ui/icons/InfoOutlined';
import HomeIcon from '@material-ui/icons/Home';
import BorderClearIcon from '@material-ui/icons/BorderClear';
import InfoCard from '../../common/InfoCard';
import AreaInfoCard from '../../common/AreaInfoCard';
import InfoCardList from '../../common/InfoCardList';
import SiteSelector from './SiteSelector';
import Title from '../../Title';
import { setCurrentPolygonId } from '../../../../../redux/parcel/Actions';
import { compose } from 'redux';
import { connect } from 'react-redux';
import PotentialUnitsText from '../../../../Common/UI/PotentialUnitsText';
import PotentialUnitsInfoCard from '../../common/PotentialUnitsInfoCard';
import BuildableAreaInfoCard from '../../common/BuildableAreaInfoCard';

class SiteInformation extends React.Component {
    static propTypes = {
        classes: PropTypes.object.isRequired,
        // Redux State
        currentPolygonId: PropTypes.number,
        currentPolygonIds: PropTypes.arrayOf(PropTypes.number),
        polygons: PropTypes.object,
        titles: PropTypes.object,
        // Redux Dispatch
        dispatchSetCurrentPolygonId: PropTypes.func.isRequired
    };

    constructor (props) {
        super(props);
    }

    render () {
        const { classes, currentPolygonId, currentPolygonIds, polygons, titles, dispatchSetCurrentPolygonId } = this.props;

        const currentPolygon = polygons[currentPolygonId];
        const isLoadingPolygon = !currentPolygon || currentPolygon.isLite || currentPolygon.isFetchingPolygon;
        const isLoadingIntersections = !currentPolygon || !currentPolygon.intersections|| currentPolygon.isFetchingIntersections;

        const area = isLoadingPolygon ? 0 : currentPolygon.area;
        const buildableArea = !isLoadingIntersections ?
            100 - Math.min(currentPolygon.intersections.find(intersection => intersection.id === null && intersection.type === 'area').value || 0, 100) : 0;

        return (
            <Fragment>
                <Title
                    title="SITE INFORMATION"
                    skeleton={isLoadingPolygon}
                >
                    {
                        currentPolygonIds.length > 1 &&
                            <Typography className={classes.warning}>
                                <WarningIcon className={classes.warningIcon} />
                                The selection contains multiple plots
                            </Typography>
                    }
                </Title>
                <SiteSelector
                    currentPolygonId={currentPolygonId}
                    currentPolygonIds={currentPolygonIds}
                    polygons={polygons}
                    titles={titles}
                    onCurrentPolygonIdChanged={dispatchSetCurrentPolygonId}
                />
                <InfoCardList>
                    <AreaInfoCard skeleton={isLoadingPolygon} value={area} />
                    <BuildableAreaInfoCard isLoading={isLoadingIntersections} buildableArea={buildableArea} />
                    <PotentialUnitsInfoCard
                        isLoading={isLoadingPolygon || isLoadingIntersections}
                        area={area}
                        buildableArea={buildableArea}
                    />
                </InfoCardList>
            </Fragment>
        );
    }
}

const style = theme => ({
    warning: {
        ...theme.typography.caption,
        display: 'flex',
        alignItems: 'center',
        lineHeight: 'initial',
        color: theme.palette.warning.main,
        marginLeft: 'auto'
    },
    warningIcon: {
        fontSize: '1.2em',
        marginRight: theme.constants.horizontalMargin * 0.5
    }
});

const mapStateToProps = (state) => ({
    currentPolygonId: state.parcelPanel.currentPolygonId,
    currentPolygonIds: state.parcelPanel.currentPolygonIds,
    polygons: state.parcelPanel.polygons,
    titles: state.parcelPanel.titles
});

const mapDispatchToProps = (dispatch) => ({
    dispatchSetCurrentPolygonId: (polygonId) => dispatch(setCurrentPolygonId(polygonId))
});

export default compose(
    connect(mapStateToProps, mapDispatchToProps),
    withStyles(style)
)(SiteInformation);